import React, {
    ChangeEvent,
    ReactElement,
    useContext,
    useEffect,
    useState
} from "react"
import Errori from "../errori/Errori"
import VisualizzaDati from "../dati/VisualizzaDati"

import axios from "axios"
import * as AppConstants from "../../utility/AppConstants"

import {
    SimpleSelectInput,
    Card,
    RadioInput
} from "@sogei/react-web-components-catalog"
import NotaMetodologicaSingoloPDF from "../../../pdf/NTM_Internet_Singolo.pdf"
import NotaMetodologicaMultiannoPDF from "../../../pdf/NTM_Internet_Multianno.pdf"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"
import {
    AnnoModel,
    CodIsaList,
    IsaBean,
    ResponseDatiNazionaliMultiAnno
} from "@/utility/model"

const radioList = [
    {
        id: "id1",
        label: "Singola Annualità",
        radioValue: "annoSingolo"
    },
    {
        id: "id2",
        label: "Multi Annualità",
        radioValue: "multiAnno"
    }
]

function Main(props: React.PropsWithChildren<any>) {
    const [datiIsa, setDatiIsa] = useState<any>([])
    const [listaCodIsa, setListaCodIsa] = useState<IsaBean[]>([])
    const [multiAnnoState, multiAnnoDispatch] = useContext(MultiAnnoContext)

    const [codIsa, setCodIsa] = useState<string | undefined>(undefined)
    const [macroarea, setMacroArea] = useState<string | undefined>(undefined)
    const [tipologia, setTipologia] = useState<string | undefined>(undefined)
    const [isMultiAnno, setIsMultiAnno] = useState<string>(
        sessionStorage.getItem("annoTypeSelection") ?? "annoSingolo"
    )
    const [listaAnni, setListaAnni] = useState<Map<number, boolean>>()

    const [rangeAnni, setRangeAnni] = useState<
        { value: string; label: string }[]
    >([])
    const initialYear =
        sessionStorage.getItem("annoSelect") != undefined
            ? sessionStorage.getItem("annoSelect")
            : "2018"

    const [anno, setAnno] = useState(initialYear as string)
    console.log(anno)

    const [viewErrori, setViewErrori] = useState<ReactElement>()
    const [viewDati, setViewDati] = useState<boolean>(false)

    const token = axios.CancelToken.source()
    useEffect(() => {
        multiAnnoDispatch({
            type: "setMultiAnno",
            value: {
                isMultiAnno:
                    (sessionStorage.getItem("annoTypeSelection") ??
                        "annoSingolo") == "multiAnno"
            }
        })

        const url = AppConstants.URL_GET_DATI_ISA
        const urlAnni = AppConstants.URL_GET_ELENCO_ANNI

        axios
            .get(url, {
                cancelToken: token.token,
                params: {
                    anno: anno
                }
            })
            .then((response) => {
                let returnCode = response.data.returnCode

                if (returnCode === "000") {
                    setDatiIsa(response.data)

                    if (!multiAnnoState.isMultiAnno) {
                        setListaCodIsa(
                            response.data.dati.find(
                                (w: any) => w.codIsaList != undefined
                            ).codIsaList
                        )
                    }
                } else {
                    setViewErrori(<Errori controllo={true} errore={true} />)
                }
            })
            .catch((err) => {
                console.log(err)

                if (
                    err.response != undefined &&
                    (err.response.status == 403 || err.response.status == 401)
                ) {
                    window.location.href = process.env.CONTEXT_PATH + "/login"
                }
                if (err.message != undefined) {
                    setViewErrori(<Errori controllo={true} errore={true} />)
                }
            })

        axios
            .get(urlAnni, {
                cancelToken: token.token,
                params: {
                    anno: anno
                }
            })
            .then((response) => {
                let returnCode = response.data.returnCode

                if (returnCode === "000") {
                    const map = new Map<number, boolean>()
                    for (const annoModel of response.data.anni as AnnoModel[]) {
                        map.set(annoModel.anno, annoModel.isCpb)
                    }

                    setListaAnni(map)

                    const valori = (response.data.anni as AnnoModel[])
                        .sort((a, b) => a.anno - b.anno)
                        .map((item, i, arr) => {
                            const nextItem = arr[i + 2]
                            if (nextItem != undefined) {
                                let val = {
                                    value: item.anno.toString(),
                                    label: `${item.anno} - ${nextItem.anno}`
                                }
                                return val
                            }
                        })
                        .filter((e) => e != undefined)

                    setRangeAnni(valori as { value: string; label: string }[])

                    multiAnnoDispatch({
                        type: "setRangeAnni",
                        value: {
                            rangeAnni: map
                        }
                    })
                } else {
                    setViewErrori(<Errori controllo={true} errore={true} />)
                }
            })
            .catch((err) => {
                if (
                    err.response != undefined &&
                    (err.response.status == 403 || err.response.status == 401)
                ) {
                    window.location.href = process.env.CONTEXT_PATH + "/login"
                }
                if (err.message != undefined) {
                    setViewErrori(<Errori controllo={true} errore={true} />)
                }
            })
        if (multiAnnoState.isMultiAnno) {
            axios
                .get(AppConstants.URL_GET_LISTA_ISA_MULTI_ANNO, {
                    params: {
                        anno: anno,
                        cancelToken: token.token
                    }
                })
                .then((response) => {
                    if (response.data.length > 0 && response.status !== 403) {
                        const data: CodIsaList = response.data

                        let values: IsaBean[] = []
                        for (const element of data[0]) {
                            let obj: (string | undefined)[]
                            let element1 = data[1].find(
                                (e) =>
                                    e.codIsa.substring(1, 4) ==
                                    element.codIsa.substring(1, 4)
                            )
                            let element2 = data[2].find(
                                (e) =>
                                    e.codIsa.substring(1, 4) ==
                                    element.codIsa.substring(1, 4)
                            )
                            obj = [
                                ...new Set([
                                    element.codIsa,
                                    element1?.codIsa ?? "",
                                    element2?.codIsa ?? ""
                                ])
                            ].filter((e) => e != "")
                            //console.log(obj, element, element1, element2);

                            if (obj.length > 1) {
                                let finale = `${obj[0]} - ${
                                    obj[obj.length - 1]
                                }`
                                values.push({
                                    codIsa: finale,
                                    descrizione: element.descrizione,
                                    id: element.id
                                })
                            } else {
                                values.push({
                                    codIsa: element.codIsa,
                                    descrizione: element.descrizione,
                                    id: element.id
                                })
                            }
                        }
                        setListaCodIsa(values)
                    }
                })
                .catch((err) => {
                    console.log("err: ", err)
                })
        }
    }, [anno, multiAnnoState.isMultiAnno])

    function visualizza(
        tipologia: string,
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) {
        e.preventDefault()
        setTipologia(tipologia)

        let controlloIsa = true
        let controlloMacroarea = true

        let macroareaParam: string | undefined = macroarea
        let codIsaParam: string | undefined = codIsa

        if (
            tipologia === AppConstants.TIPOLOGIA_DATI_NAZIONALI_ISA ||
            tipologia === AppConstants.TIPOLOGIA_DATI_REGIONALI_ISA
        ) {
            if (codIsa === undefined || codIsa === null) controlloIsa = false
        } else if (
            tipologia === AppConstants.TIPOLOGIA_DATI_NAZIONALI_MACRO ||
            tipologia === AppConstants.TIPOLOGIA_DATI_REGIONALI_MACRO
        ) {
            if (macroarea === undefined || macroarea === null)
                controlloMacroarea = false
        } else {
            // si tratta di tutti gli ISA;
            codIsaParam = undefined
            macroareaParam = undefined
        }

        setCodIsa(codIsaParam)
        setMacroArea(macroareaParam)

        if (!controlloIsa) {
            setViewDati(false)
            setViewErrori(
                <Errori
                    controllo={false}
                    errore={false}
                    messaggio="Selezionare un CODICE ISA"
                />
            )
        } else if (!controlloMacroarea) {
            setViewDati(false)
            setViewErrori(
                <Errori
                    controllo={false}
                    errore={false}
                    messaggio="Selezionare un MACROSETTORE"
                />
            )
        } else {
            setViewDati(true)
        }
    }

    function handleChangeMacroArea(e: ChangeEvent<HTMLSelectElement>) {
        setMacroArea(e.target.value)
    }
    function handleChangeCodIsa(e: ChangeEvent<HTMLSelectElement>) {
        setCodIsa(e.target.value)
    }
    function handleChangeAnno(e: ChangeEvent<HTMLSelectElement>) {
        setAnno(e.target.value)
        sessionStorage.setItem("annoSelect", e.target.value)
    }

    const handleRadioChange = (e: ChangeEvent<HTMLInputElement>) => {
        multiAnnoDispatch({
            type: "setMultiAnno",
            value: { isMultiAnno: e.target.value == "multiAnno" }
        })

        if (e.target.value == "multiAnno") {
            setAnno(rangeAnni[0]?.value ?? initialYear)
            sessionStorage.setItem(
                "annoSelect",
                rangeAnni[0]?.value ?? initialYear
            )
        } else {
            setAnno(
                listaAnni
                    ?.keys()
                    .toArray()
                    .toSorted((a, b) => Number(a) - Number(b))[0]
                    .toString() as string
            )
            sessionStorage.setItem(
                "annoSelect",
                listaAnni
                    ?.keys()
                    .toArray()
                    .toSorted((a, b) => Number(a) - Number(b))[0]
                    .toString() as string
            )
        }

        setIsMultiAnno(e.target.value)
        sessionStorage.setItem("annoTypeSelection", e.target.value)
    }

    if (viewDati) {
        return (
            <VisualizzaDati
                tipologia={tipologia}
                anno={anno}
                codIsa={codIsa}
                macroarea={macroarea}
            />
        )
    } else {
        return (
            <div className="main-min-vh" role="main">
                {props.children}
                <div className="container-fluid py-3 py-md-4">
                    <div className="row">
                        <div className="col-auto ">
                            <h1>
                                <label
                                    htmlFor="input-select-inline"
                                    className="mr-2 label-form"
                                >
                                    DATI ISA:
                                </label>
                            </h1>
                        </div>
                        <div className="col-auto">
                            <form className="form-inline">
                                <div className="form-group">
                                    <span className="sr-only">
                                        {" "}
                                        Selezionare l'anno per la
                                        visualizzazione delle statistiche ISA{" "}
                                    </span>
                                    <div className="mr-5">
                                        <RadioInput
                                            name="multianno-radio"
                                            value={isMultiAnno}
                                            inline={true}
                                            legend="Seleziona Modalità"
                                            radioList={radioList}
                                            inputClass={[]}
                                            labelClass={[]}
                                            event={{
                                                onChange: handleRadioChange
                                            }}
                                        ></RadioInput>
                                    </div>

                                    {!multiAnnoState.isMultiAnno ? (
                                        <SimpleSelectInput
                                            id="input-select-inline"
                                            name="input-select-inline"
                                            value={anno}
                                            // dimension="lg"
                                            //label="Select"
                                            firstEmptyOption={false}
                                            optionList={listaAnni
                                                ?.keys()
                                                .toArray()
                                                .sort()
                                                .map((annoElem, key) => ({
                                                    optionValue: annoElem,
                                                    optionLabel: annoElem
                                                }))}
                                            //error={this.state.error}
                                            inputClass={[
                                                "form-control",
                                                "select-isa"
                                            ]}
                                            labelClass={[]}
                                            event={{
                                                onChange: handleChangeAnno
                                            }}
                                            //extraProps={extraProps}
                                        ></SimpleSelectInput>
                                    ) : (
                                        <SimpleSelectInput
                                            id="input-select-multi-inline"
                                            name="input-select-multi-inline"
                                            value={anno}
                                            // dimension="lg"
                                            //label="Select"
                                            firstEmptyOption={false}
                                            optionList={rangeAnni.map((el) => ({
                                                optionValue: el.value,
                                                optionLabel: el.label
                                            }))}
                                            //error={this.state.error}
                                            inputClass={[
                                                "form-control",
                                                "select-isa"
                                            ]}
                                            labelClass={[]}
                                            event={{
                                                onChange: handleChangeAnno
                                            }}
                                            //extraProps={extraProps}
                                        ></SimpleSelectInput>
                                    )}
                                </div>
                            </form>
                        </div>
                        <div className="col">&nbsp;</div>
                        <div className="col-auto">
                            <a
                                href={
                                    !multiAnnoState.isMultiAnno
                                        ? NotaMetodologicaSingoloPDF
                                        : NotaMetodologicaMultiannoPDF
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Nota Metodologica"
                            >
                                <span className="fas fa-info-circle fa-3x mr-2"></span>
                            </a>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">{viewErrori}</div>
                    </div>

                    <div className="row">
                        {datiIsa.dati !== undefined ? (
                            datiIsa.dati.map(
                                (
                                    dati: {
                                        id: number
                                        titolo: {} | null | undefined
                                        descrizione:
                                            | boolean
                                            | React.ReactChild
                                            | React.ReactFragment
                                            | React.ReactPortal
                                            | null
                                            | undefined
                                        macroAreaList: any[] | null | undefined
                                        codIsaList: any[] | null | undefined
                                        tipologia: string
                                    },
                                    keyDati: string
                                ) => (
                                    <div
                                        className="col-12 col-md-4 py-2"
                                        key={keyDati + "_div"}
                                    >
                                        <Card
                                            rootClass={["h-100"]}
                                            title={dati.titolo}
                                            body={
                                                <div>
                                                    <div className="row">
                                                        <div className="col-12 py-2">
                                                            {dati.descrizione}
                                                        </div>

                                                        <div className="col-12">
                                                            {dati.macroAreaList !==
                                                                null &&
                                                            dati.macroAreaList !==
                                                                undefined ? (
                                                                <SimpleSelectInput
                                                                    id={
                                                                        keyDati +
                                                                        "_input"
                                                                    }
                                                                    name="input-select-inline"
                                                                    // value={macroarea}
                                                                    // dimension="lg"
                                                                    //label="Select"
                                                                    firstEmptyOption={
                                                                        true
                                                                    }
                                                                    optionList={dati.macroAreaList.map(
                                                                        (
                                                                            macro,
                                                                            keyMacro
                                                                        ) => ({
                                                                            optionValue:
                                                                                macro.macroArea,
                                                                            optionLabel:
                                                                                macro.macroArea
                                                                        })
                                                                    )}
                                                                    //error={this.state.error}
                                                                    inputClass={[
                                                                        "form-control"
                                                                    ]}
                                                                    labelClass={[]}
                                                                    event={{
                                                                        onChange:
                                                                            handleChangeMacroArea
                                                                    }}
                                                                    //extraProps={extraProps}
                                                                ></SimpleSelectInput>
                                                            ) : (
                                                                <React.Fragment />
                                                            )}

                                                            {dati.codIsaList !==
                                                                null &&
                                                            dati.codIsaList !==
                                                                undefined ? (
                                                                <SimpleSelectInput
                                                                    id={
                                                                        keyDati +
                                                                        "_input"
                                                                    }
                                                                    name="input-select-inline"
                                                                    //value={codIsa}
                                                                    // dimension="lg"
                                                                    //label="Select"
                                                                    firstEmptyOption={
                                                                        true
                                                                    }
                                                                    optionList={listaCodIsa.map(
                                                                        (
                                                                            codIsaElem,
                                                                            keyIsa
                                                                        ) => ({
                                                                            optionValue:
                                                                                multiAnnoState.isMultiAnno
                                                                                    ? codIsaElem.codIsa.split(
                                                                                          " - "
                                                                                      )[0]
                                                                                    : codIsaElem.codIsa,
                                                                            optionLabel: `${codIsaElem.codIsa} - ${codIsaElem.descrizione}`
                                                                        })
                                                                    )}
                                                                    //error={this.state.error}
                                                                    inputClass={[
                                                                        "form-control"
                                                                    ]}
                                                                    labelClass={[]}
                                                                    event={{
                                                                        onChange:
                                                                            handleChangeCodIsa
                                                                    }}
                                                                    //extraProps={extraProps}
                                                                ></SimpleSelectInput>
                                                            ) : (
                                                                <React.Fragment />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            footer={
                                                <a
                                                    className="btn btn-primary"
                                                    href="visualizza"
                                                    onClick={(e) =>
                                                        visualizza(
                                                            dati.tipologia,
                                                            e
                                                        )
                                                    }
                                                >
                                                    Visualizza
                                                    <i className="fas fa-arrow-right ml-2"></i>
                                                </a>
                                            }
                                            footerAlign="right"
                                        />
                                    </div>
                                )
                            )
                        ) : (
                            <React.Fragment />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
export default Main
